import React, { useEffect, useMemo, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Form,
  Modal,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Pagi2 from "common/utils/Pagi2"
import { CommonTableContainer } from "common/utils/ComonTableContainer"
import "../../common/styles/contract.css"
import Swal from 'sweetalert2'
import DemoPdf from "../../assets/PDF/blank.pdf"
import configure from "configure"
import axios from "axios"
import AccessDeniedPopup from "components/Common/AccessDeniedPopup"
import Loader from "components/Common/Loader"
import moment from "moment"
import secureLocalStorage from "react-secure-storage"
import Pagination from "common/utils/Pagination"
import { customGlobalFilter } from "utils/common-helpers"


const ContractIndex = () => {
  const [fixedContent, setFixedContent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    fetchContract()
  }, [])

  const fetchContract = async () => {
    setLoading(true)
    const authUser = secureLocalStorage.getItem("Token");
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/contracts`,
        // data: formData,
        headers: {
          Authorization: `Bearer ${authUser}`,
        }
      }).then(res => {
        setData(res.data.contracts)
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
      console.log("fetchContract Error", error)
    }
  }


  document.title = "Contract | Zithas Technologies"


  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })



  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "contract_id",
        Cell: cellProps => {
          return (
            <div className="text-center">
              {cellProps.row.original.id}
            </div>
          )
        }
      },

      {
        Header: "Company",
        accessor: "company",
        isInfoIcon: false,
        isShortIcon: true,
        className: "contact_company",
        Cell: cellProps => {
          const company = secureLocalStorage.getItem('User')
          return (
            <div className="text-start">
              {cellProps.row.original?.customerDetails?.company || "-"}
            </div>
          )
        }
      },
      {
        Header: "Type",
        accessor: "contract_type",
        isInfoIcon: false,
        isShortIcon: true,
        className: "contract_type",
        Cell: cellProps => {
          return (
            <div className="">

              <div className="pt-1 ms-2">
                {cellProps.row.original?.contractTypes?.contract_type || "-"}
              </div>
            </div>
          )
        },
      },
      {
        Header: "Amount",
        accessor: "value",
        className: "text-center",
        Cell: cellProps => {
          return (
            <div>
              {cellProps.row.original.value != null ? (
                <>
                  {cellProps.row.original.currency_symbol}
                  {cellProps.row.original.value}
                </>
              ) : (
                "-"
              )}
            </div>
          )
        },
      },

      {
        Header: "Duration",
        accessor: "daysDifference",
        isInfoIcon: false,
        isShortIcon: true,
        className: "contract_duration",
        Cell: cellProps => {
          const startDate = new Date(cellProps.row.original.startdate)
          const endDate = new Date(cellProps.row.original.enddate)
          const timeDifference = endDate - startDate
          const daysDifference = Math.floor(
            timeDifference / (1000 * 60 * 60 * 24)
          )
          return (
            <div className="text-center">
              {daysDifference} Days
            </div>
          )
        }
      },
      {
        Header: "Sent Date",
        accessor: "startdate",
        isInfoIcon: false,
        isShortIcon: true,
        className: "sent_date",
        Cell: cellProps => {
          return (
            <div className="text-center">

              {
                cellProps.row.original?.startdate != null ? moment(cellProps.row.original?.startdate.slice(0, 10)).format("DD-MM-YYYY") : "-"
              }
            </div>
          )
        }
      },
      {
        Header: "End Date",
        accessor: "enddate",
        isInfoIcon: false,
        isShortIcon: true,
        className: "end_date",
        Cell: cellProps => {
          return (
            <div className="text-center">
              {
                cellProps.row.original.enddate != null ? moment(cellProps.row.original.enddate.slice(0, 10)).format("DD-MM-YYYY") : "-"
              }
            </div>
          )
        }
      },
      {
        Header: "Signature",
        accessor: "has_signature",
        isInfoIcon: false,
        isShortIcon: true,
        className: "contract_signature",
        Cell: cellProps => {
          const signature = cellProps.row.original.has_signature
          return (
            <div className="text-center">
              {signature == false ? (
                <span className="bg-danger text-capitalize badge">
                  Not Signed
                </span>
              ) : signature == true ? (
                <span className="bg-success text-capitalize badge">
                  Signed
                </span>
              ) : null
              }
            </div>

          )
        }
      },

      {
        Header: "Action",
        accessor: "action",
        className: "contract_action",
        isInfoIcon: false,
        Cell: cellProps => {

          return (
            <>
              <div className="d-flex justify-content-center">
                <Link
                  to={`${configure.appUrl}/view-contract/${cellProps.row.original.id}`}
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="View Contract"
                >
                  <i className="fas fa-eye "></i>
                </Link>
              </div>
            </>
          )
        },
      },
    ],
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        pageIndex: 0,
        sortBy: [{ id: "id", desc: true }],
      },
    },
    useGlobalFilter,
    usePagination
  )



  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Contract"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <div>
                      {/* fixed buttons */}
                      <div
                        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                          }`}
                      >
                        {/* <Link
                         to="/add_proposal" 
                         className=" btn ms-md-2 btn-save btn-label">
                            <i className="fas fa-plus me-1 label-icon"></i> Proposal
                        </Link>     */}
                        <button
                          onClick={() => navigate(-1)}
                          className="btn btn-red  fix-btn btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          <span>Cancel</span>
                        </button>
                      </div>
                      <Row className="mb-2">
                        <Col className="col-2">
                          <select
                            className=" me-4 form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={e => setPageSize(e.target.value)}
                          >
                            {[10, 25, 50, 100].map(pageSize => (
                              <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col className="col-10 d-flex justify-content-end">
                          <div className="me-3">
                            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                              <div className="position-relative">
                                <label
                                  htmlFor="search-bar-0"
                                  className="search-label"
                                >
                                  <span
                                    id="search-bar-0-label"
                                    className="sr-only"
                                  >
                                    Search this table
                                  </span>
                                  <input
                                    onChange={e =>
                                      setGlobalFilter(e.target.value)
                                    }
                                    id="search-bar-0"
                                    type="text"
                                    className=" form-control rounded h-100"
                                    placeholder={`Search...`}
                                    value={globalFilter || ""}
                                  />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                              </div>
                            </div>
                          </div>

                          <div className="text-md-end">
                            {/* <Link
                             to="/add_proposal" 
                             className=" btn ms-md-2 btn-save  btn-label me-2">
                                <i className="fas fa-plus me-1 label-icon"></i> Proposal
                            </Link>  */}
                            <button
                              onClick={() => navigate(-1)}
                              className=" btn btn-red btn-label"
                            >
                              <i className="dripicons-cross me-2  lab label-icon"></i>
                              CANCEL
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row>

                        <div className="col-12">
                          <div className="position-relative shadow">
                            <table
                              className="table table-bordered mt-4"
                              {...getTableProps()}
                            >
                              <thead
                                className={`${fixedContent ? "fix-header" : ""
                                  } fix-lead-header`}
                              >
                                {headerGroups.map((headerGroup, i) => (
                                  <tr
                                    key={i}
                                    {...headerGroup.getHeaderGroupProps()}
                                  >
                                    {headerGroup.headers.map((column, index) => (
                                      <th
                                        key={index}
                                        className={`t-col-${index + 1} ${column.className
                                          }`}
                                        {...column.getHeaderProps()}
                                      >
                                        {column.render("Header")}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody
                                className="fix-lead-header"
                                {...getTableBodyProps()}
                              >
                                {page.map((row, i) => {
                                  prepareRow(row)
                                  let backColor
                                  if (row.original.lead_type == "Hot") {
                                    backColor = "bd-hot"
                                  }
                                  return (
                                    <tr
                                      className={`row-hover ${backColor}`}
                                      {...row.getRowProps()}
                                      key={i}
                                    >
                                      {row.cells.map((cell, index) => {
                                        return (
                                          <td
                                            key={index}

                                            className={`t-col-${index + 1} ${cell.column.className
                                              }`}
                                            {...cell.getCellProps()}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        )
                                      })}
                                    </tr>
                                  )
                                })}
                                {page.length == 0 ? (
                                  <tr>
                                    <td className="text-center" colSpan={10}>
                                      No Leads Available
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>


                      {/* Pagination */}
                      <Row className="justify-content-md-end justify-content-center align-items-center">
                        <Pagination
                          gotoPage={gotoPage}
                          previousPage={previousPage}
                          canPreviousPage={canPreviousPage}
                          nextPage={nextPage}
                          canNextPage={canNextPage}
                          pageIndex={pageIndex}
                          pageOptions={pageOptions}
                        />
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ContractIndex
